import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { delayRetrieveRecords } from '../store/actions/search';
import { changePropertyFilter } from '../store/actions/query';
import { getPropertyFilter } from '../store/selectors/query';

import { isPresent } from 'helpers/string_helpers';

import FilterButton from 'components/ui/filter_button';
import FilterNumberPair from "components/search_sidebar/filter_number_pair";
import FilterSelect from "components/search_sidebar/filter_select";
import FilterDatePickerPair from 'components/search_sidebar/filter_datepicker_pair';
import { filterLabelMappings, filterKeyMappings } from '../../requirements_constants';
import { Col, Row } from 'react-bootstrap-5';
export class PropertyFilter extends React.Component {
  sizeUnits = [{ id: 'acres', value: 'acres', label: 'Acres' }];

  static propTypes = {
    delayRetrieveRecords: PropTypes.func.isRequired,
    propertyFilter: PropTypes.shape({
      buildingSizeUnits: PropTypes.string.isRequired,
      lotSizeUnits: PropTypes.string.isRequired,
      maxBuildingSize: PropTypes.string.isRequired,
      maxLeaseDate: PropTypes.string.isRequired,
      maxLotSize: PropTypes.string.isRequired,
      maxPrice: PropTypes.string.isRequired,
      maxUnits: PropTypes.string.isRequired,
      minBuildingSize: PropTypes.string.isRequired,
      minLeaseDate: PropTypes.string.isRequired,
      minLotSize: PropTypes.string.isRequired,
      minPrice: PropTypes.string.isRequired,
      minUnits: PropTypes.string.isRequired
    }),
    onPropertyFilterChange: PropTypes.func.isRequired,
  }

  handlePropertyFilterChange = (e, name) => {
    const { propertyFilter, onPropertyFilterChange, delayRetrieveRecords } = this.props;
    let value = "";
    if (e && e.target) {
      value = e.target.value;
    } else {
      value = e;
    }

    propertyFilter[name] = value;
    onPropertyFilterChange(propertyFilter);
    delayRetrieveRecords();
  }

  render() {
    const { propertyFilter } = this.props;

    const filtersApplied = Object.keys(propertyFilter).some((k) => {
      return (isPresent(propertyFilter[k]) && k != "buildingSizeUnits");
    });

    return (
      <FilterButton
        filtersApplied={filtersApplied}
        label="Property Details"
        name="property-details-popover"
      >
        <div className="d-flex flex-column gap-2">
          <Row className="gx-2 align-items-end">
            <Col md={9}>
              <FilterNumberPair
                filter={propertyFilter}
                label={filterLabelMappings['buildingSize']}
                name="buildingSize"
                valueKeys={filterKeyMappings['buildingSize']}
                onChange={this.handlePropertyFilterChange}
              />
            </Col>
            <Col md={3} className="d-none d-md-flex">
              <FilterSelect
                defaultValue="sf"
                options={this.sizeUnits}
                placeholder="SF"
                value={propertyFilter.buildingSizeUnits}
                onChange={e => this.handlePropertyFilterChange(e, 'buildingSizeUnits')}
              />
            </Col>
          </Row>
          <Row className="gx-2 align-items-end">
            <Col md={9}>
              <FilterNumberPair
                filter={propertyFilter}
                label={filterLabelMappings['lotSize']}
                name="lotSize"
                valueKeys={filterKeyMappings['lotSize']}
                onChange={this.handlePropertyFilterChange}
              />
            </Col>
            <Col md={3} className="d-none d-md-flex">
              <FilterSelect
                defaultValue="sf"
                options={this.sizeUnits}
                placeholder="SF"
                value={propertyFilter.lotSizeUnits}
                onChange={e => this.handlePropertyFilterChange(e, 'lotSizeUnits')}
              />
            </Col>
          </Row>
          {this.renderPropertyFilter("units")}
          {this.renderPropertyFilter("price")}
          {this.renderDateFilter("leaseDate")}
        </div>
      </FilterButton>
    );
  }

  renderPropertyFilter(key) {
    const { propertyFilter } = this.props;

    return (
      <>
        <div>
          <FilterNumberPair
            filter={propertyFilter}
            label={filterLabelMappings[key]}
            name={`${key}-filter`}
            valueKeys={filterKeyMappings[key]}
            onChange={this.handlePropertyFilterChange}
          />
        </div>
      </>
    );
  }

  renderDateFilter(key) {
    const { propertyFilter } = this.props;

    return (
      <>
        <div>
          <FilterDatePickerPair
            filter={propertyFilter}
            label={filterLabelMappings[key]}
            valueKeys={filterKeyMappings[key]}
            onChange={this.handlePropertyFilterChange}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  propertyFilter: getPropertyFilter(state)
});

const mapDispatchToProps = {
  delayRetrieveRecords,
  onPropertyFilterChange: changePropertyFilter
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertyFilter);
